import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  agentId: null,
  campaignId: null,
  agentPass: null,
  loggedIn: false,
  loginWait: false,
  loginType: null,
  error: null,
  loading: false,
  //Agent Data
  agentState: null,
  dialerType: null,
  campaignDialerType: null,
  previewDialing: null,
  manualDial: null,
  initiateScreenRec: null,
  isHold: null,
  holdTime: 0,
  ivrsPath: null,
  sessionId: null,
  leadId: null,
  callType: null,
  phType: null,
  custPhone: null,
  lastCustPhone: null,
  callDuration: 0,
  agentName: null,
  callBackLive: null,
  isEscalation: null,
  skills: null,
  didNum: null,
  leadAttemptCount: null,
  custUniqueId: null,
  listName: null,
  isTransfer: null,
  autoMode: null,
  detail: null,
  lastActivityTime: 0,
  autoReadyFlag: null,
  autoReadyTime: null,
  failedReason: null,
  wrapTime: null,
  wrpupDisconnectFlag: null,
  breakType: null,
  callBack: null,
  pausedTime: null,
  allowedTime: null,
  agentInConf: 0,
  rdFlag: 0,
  callParkCount: null,
  callsInQueue: 0,
  multiConfEnabled: 0,
  mandatory: 0,
  callCategory: null,
  language: null,
  boxDate: null,
  boxTime: null,
  nextActionOnLead: 0,
  registerstatus: null,
};

const agentLoginStart = (state, action) => {
  return updateObject(state, {error: null, loading: true});
};

const agentLoginSuccess = (state, action) => {
  return updateObject(state, {
    agentId: action.agentId,
    loggedIn: true,
    loginWait: false,
    error: null,
    loading: false,
  });
};

export const agentLoginWait = (state, action) => {
  return updateObject(state, {
    agentId: action.agentId,
    loggedIn: false,
    loginWait: true,
    error: action.error,
    loading: false,
  });
};

const agentLoginFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const agentLogoutStart = (state, action) => {
  return updateObject(state, {error: null, loading: true});
};

const agentLogoutFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const agentLogoutSuccess = (state, action) => {
  return updateObject(state, {
    agentId: null,
    campaignId: null,
    agentPass: null,
    loggedIn: false,
    loginWait: false,
    loginType: null,
    error: null,
    loading: false,
    //Agent Data
    agentState: null,
    dialerType: null,
    campaignDialerType: null,
    previewDialing: null,
    manualDial: null,
    initiateScreenRec: null,
    isHold: null,
    holdTime: 0,
    ivrsPath: null,
    sessionId: null,
    leadId: null,
    callType: null,
    phType: null,
    custPhone: null,
    lastCustPhone: null,
    callDuration: null,
    agentName: null,
    callBackLive: null,
    isEscalation: null,
    skills: null,
    didNum: null,
    leadAttemptCount: null,
    custUniqueId: null,
    listName: null,
    isTransfer: null,
    autoMode: null,
    detail: null,
    lastActivityTime: null,
    autoReadyFlag: null,
    autoReadyTime: null,
    failedReason: null,
    wrapTime: null,
    wrpupDisconnectFlag: null,
    breakType: null,
    callBack: null,
    pausedTime: null,
    allowedTime: null,
    agentInConf: 0,
    rdFlag: 0,
    callParkCount: null,
    callsInQueue: 0,
    multiConfEnabled: 0,
    mandatory: 0,
    callCategory: null,
    language: null,
    boxDate: null,
    boxTime: null,
    nextActionOnLead: 0,
    registerstatus: 0,
  });
};

export const agentStateUpdate = (state, action) => {
  return updateObject(state, {
    agentId: action.agentId,
    campaignId: action.campaignId,
    loggedIn: true,
    loginWait: false,
    loginType: action.loginType,
    error: null,
    loading: false,
    //Agent Data
    agentState: action.agentState,
    dialerType: action.dialerType,
    campaignDialerType: action.campaignDialerType,
    previewDialing: action.previewDialing,
    manualDial: action.manualDial,
    initiateScreenRec: action.initiateScreenRec,
    isHold: action.isHold,
    holdTime: action.holdTime,
    ivrsPath: action.ivrsPath,
    sessionId: action.sessionId,
    leadId: action.leadId,
    callType: action.callType,
    phType: action.phType,
    custPhone: action.custPhone,
    lastCustPhone: action.lastCustPhone,
    callDuration: action.callDuration,
    agentName: action.agentName,
    callBackLive: action.callBackLive,
    isEscalation: action.isEscalation,
    skills: action.skills,
    didNum: action.didNum,
    leadAttemptCount: action.leadAttemptCount,
    custUniqueId: action.custUniqueId,
    listName: action.listName,
    isTransfer: action.isTransfer,
    autoMode: action.autoMode,
    detail: action.detail,
    lastActivityTime: action.lastActivityTime,
    autoReadyFlag: action.autoReadyFlag,
    autoReadyTime: action.autoReadyTime,
    failedReason: action.failedReason,
    wrapTime: action.wrapTime,
    wrpupDisconnectFlag: action.wrpupDisconnectFlag,
    breakType: action.breakType,
    callBack: action.callBack,
    pausedTime: action.pausedTime,
    allowedTime: action.allowedTime,
    agentInConf: action.agentInConf,
    rdFlag: action.rdFlag,
    callParkCount: action.callParkCount,
    callsInQueue: action.callsInQueue,
    multiConfEnabled : action.multiConfEnabled,
    mandatory: action.mandatory,
    callCategory: action.callCategory,
    language: action.language,
    boxDate: action.boxDate,
    boxTime: action.boxTime,
    nextActionOnLead: action.nextActionOnLead,
    registerstatus: action.registerstatus,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AGENT_LOGIN_START:
      return agentLoginStart(state, action);
    case actionTypes.AGENT_LOGIN_SUCCESS:
      return agentLoginSuccess(state, action);
    case actionTypes.AGENT_LOGIN_WAIT:
      return agentLoginWait(state, action);
    case actionTypes.AGENT_LOGIN_FAIL:
      return agentLoginFail(state, action);
    case actionTypes.AGENT_LOGOUT_START:
      return agentLogoutStart(state, action);
    case actionTypes.AGENT_LOGOUT_SUCCESS:
      return agentLogoutSuccess(state, action);
    case actionTypes.AGENT_LOGOUT_FAIL:
      return agentLogoutFail(state, action);
    case actionTypes.AGENT_STATE_UPDATE:
      return agentStateUpdate(state, action);
    default:
      return state;
  }
};

export default reducer;
